module.exports = __webpack_public_path__ + "static/media/team_4.f334cd5b.png";